// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.google-disclosure-header {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.google-disclosure-header .google-disclosure-title {
  flex-grow: 1;
  text-align: center;
  padding: 0px 20px;
}

.google-disclosure-content-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.google-disclosure-content-container .google-disclosure-card {
  width: 90%;
  max-width: 900px;
  margin-bottom: 24px;
  padding: 24px;
  text-align: left;
}

@media screen and (max-width: 1156px) {
  .google-disclosure-content-container {
    margin-top: 12px;
  }
  .google-disclosure-content-container .google-disclosure-card {
    width: 90%;
    margin-bottom: 12px;
    padding: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/meeting-manager/google-disclosure/google-disclosure.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AACF;AACE;EACE,YAAA;EACA,kBAAA;EACA,iBAAA;AACJ;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAAF;AAEE;EACE,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AAAJ;;AAIA;EACE;IACE,gBAAA;EADF;EAGE;IACE,UAAA;IACA,mBAAA;IACA,aAAA;EADJ;AACF","sourcesContent":[".google-disclosure-header {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n\n  .google-disclosure-title {\n    flex-grow: 1;\n    text-align: center;\n    padding: 0px 20px;\n  }\n}\n\n.google-disclosure-content-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  .google-disclosure-card {\n    width: 90%;\n    max-width: 900px;\n    margin-bottom: 24px;\n    padding: 24px;\n    text-align: left;\n  }\n}\n\n@media screen and (max-width: 1156px) {\n  .google-disclosure-content-container {\n    margin-top: 12px;\n\n    .google-disclosure-card {\n      width: 90%;\n      margin-bottom: 12px;\n      padding: 12px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
